__turbopack_context__.v({
  "carouselControls": "ImagesCarouselSection-module__SOI7xq__carouselControls",
  "carouselSection": "ImagesCarouselSection-module__SOI7xq__carouselSection",
  "description": "ImagesCarouselSection-module__SOI7xq__description",
  "embla": "ImagesCarouselSection-module__SOI7xq__embla",
  "embla__container": "ImagesCarouselSection-module__SOI7xq__embla__container",
  "embla__next": "ImagesCarouselSection-module__SOI7xq__embla__next",
  "embla__prev": "ImagesCarouselSection-module__SOI7xq__embla__prev",
  "embla__slide": "ImagesCarouselSection-module__SOI7xq__embla__slide",
  "imagesCarouselSection": "ImagesCarouselSection-module__SOI7xq__imagesCarouselSection",
  "slideContent": "ImagesCarouselSection-module__SOI7xq__slideContent",
  "textContainer": "ImagesCarouselSection-module__SOI7xq__textContainer",
  "title": "ImagesCarouselSection-module__SOI7xq__title",
});
